import React, { useState } from 'react';
import { classNames } from '../../../utils';
import { TabClientsIcon, TabDriversIcon, TabModeratorsIcon, TabOwnersIcon } from '../../../assets/icons';
import Clients from './clients';
import Owners from './owners';
import Drivers from './drivers';
import Moderators from './moderators';

const TAB = {
  CLIENTS: 1,
  OWNERS: 2,
  DRIVERS: 3,
  MODERATORS: 4,
}

const Users = () => {
  const [tab, setTab] = useState(TAB.CLIENTS);

  return (
    <main className="p-4 w-full">
      {tab === TAB.CLIENTS && (
        <Clients tabs={<Tabs tab={tab} setTab={setTab} />} />
      )}
      {tab === TAB.OWNERS && (
        <Owners tabs={<Tabs tab={tab} setTab={setTab} />} />
      )}
      {tab === TAB.DRIVERS && (
        <Drivers tabs={<Tabs tab={tab} setTab={setTab} />} />
      )}
      {tab === TAB.MODERATORS && (
        <Moderators tabs={<Tabs tab={tab} setTab={setTab} />} />
      )}
    </main>
  );
};

const Tabs = ({ tab, setTab }) => (
  <div className="flex items-center gap-4 my-2">
    <Tab
      label="Clientes"
      icon={TabClientsIcon}
      isActive={tab === TAB.CLIENTS}
      onClick={() => setTab(TAB.CLIENTS)}
    />
    <Tab
      label="Propietarios"
      icon={TabOwnersIcon}
      isActive={tab === TAB.OWNERS}
      onClick={() => setTab(TAB.OWNERS)}
    />
    <Tab
      label="Conductores"
      icon={TabDriversIcon}
      isActive={tab === TAB.DRIVERS}
      onClick={() => setTab(TAB.DRIVERS)}
    />
    <Tab
      label="Moderadores"
      icon={TabModeratorsIcon}
      isActive={tab === TAB.MODERATORS}
      onClick={() => setTab(TAB.MODERATORS)}
    />
  </div>
)

const Tab = ({ label, icon, isActive, onClick }) => (
  <button
    className={classNames('flex items-center gap-2 p-3 rounded-xl text-sm font-semibold shadow-md', isActive ? 'bg-orange' : 'bg-white')}
    onClick={onClick}
  >
    <div className={classNames('w-10 h-10 rounded-full flex items-center justify-center', isActive ? 'bg-white' : 'bg-[#F5F7FA]')}>
      <img src={icon} className={classNames('w-5 h-5 object-contain', isActive ? 'text-white' : 'text-orange')} alt="" />
    </div>
    <span className={classNames(' text-lg', isActive ? 'text-white' : 'black')}>{ label }</span>
  </button>
)

export default Users;